import React from "react";
import ReactDOM from "react-dom/client";
import "@kuda/ui/fonts.css";
import "@kuda/ui/tokens/primitives.css";
import "@kuda/ui/tokens/theme-retail-light.css";
import "@kuda/ui/tokens/theme-retail-dark.css";
import "@kuda/ui/css";
import "./theme/kuda-overrides.css";
// import "./index.css";
import App from "./App";
import pca from "./auth/userAuth";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <App msalInstance={pca} />
    </BrowserRouter>
);
